import React from "react";
import { Box } from "@mui/material";
import { colors, fonts, layout } from "../../theme/tokens";

const values = [
  {
    title: "Excellence",
    body: "We hold ourselves to the highest standards of professional quality in every engagement.",
  },
  {
    title: "Integrity",
    body: "We act with honesty and transparency, protecting the trust our clients place in us.",
  },
  {
    title: "Partnership",
    body: "We work alongside clients as collaborative partners, invested in long-term success.",
  },
  {
    title: "Impact",
    body: "We focus on delivering measurable results that create real, lasting value.",
  },
  {
    title: "Innovation",
    body: "We embrace modern approaches and technology to deliver forward-thinking solutions.",
  },
  {
    title: "Sustainability",
    body: "We design strategies that promote enduring growth and operational resilience.",
  },
];

const CoreValues = () => {
  return (
    <Box
      component="section"
      sx={{ py: "56px", px: { xs: "20px", md: "28px" } }}
    >
      <Box sx={{ maxWidth: layout.maxWidth, mx: "auto" }}>
        <Box sx={{ mb: "40px", maxWidth: "620px" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              OUR VALUES
            </Box>
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(28px,3.4vw,42px)",
              lineHeight: 1.1,
              letterSpacing: "-.02em",
              color: colors.navyInk,
              mt: "16px",
              mb: 0,
            }}
          >
            The principles that guide us
          </Box>
          <Box
            sx={{
              fontFamily: fonts.body,
              fontSize: "16px",
              lineHeight: 1.65,
              color: colors.mutedText,
              mt: "14px",
            }}
          >
            Our values shape how we approach every project, every relationship,
            and every decision we make.
          </Box>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(3,1fr)",
            },
            gap: "16px",
          }}
        >
          {values.map((v, i) => (
            <Box
              key={v.title}
              sx={{
                background: "#fff",
                border: `1px solid ${colors.lineSoft}`,
                borderRadius: "20px",
                p: "30px 28px",
                display: "flex",
                gap: "18px",
                alignItems: "flex-start",
                transition: "transform .4s cubic-bezier(.2,.7,.2,1)",
                "&:hover": {
                  transform: "translateY(-6px)",
                  "& .val-num": { color: colors.amber },
                },
              }}
            >
              <Box
                className="val-num"
                sx={{
                  fontFamily: fonts.display,
                  fontWeight: 700,
                  fontSize: "24px",
                  color: "#C7D2DD",
                  transition: "color .3s",
                  flex: "none",
                  lineHeight: 1.1,
                }}
              >
                {String(i + 1).padStart(2, "0")}
              </Box>
              <Box>
                <Box
                  component="h3"
                  sx={{
                    fontFamily: fonts.display,
                    fontWeight: 600,
                    fontSize: "19px",
                    color: colors.navyInk,
                    m: 0,
                  }}
                >
                  {v.title}
                </Box>
                <Box
                  sx={{
                    fontFamily: fonts.body,
                    fontSize: "14px",
                    lineHeight: 1.6,
                    color: "#6A7888",
                    mt: "8px",
                  }}
                >
                  {v.body}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CoreValues;
